import { triggerAlert } from "redux/appSetting/actions";
import localize from "./localize";

export const errorHandling = (er:any,dispatch:any,key:string) =>{
    // console.log({er})
    if(er.message !== 'canceled') {
        return dispatch(triggerAlert(localize(key),"error"))
    }
    return;
}